"use client";

import { Quote } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
interface Testimonial {
  id: number;
  name: string;
  projectType: string;
  location: string;
  description: string;
  beforeImage: string;
  afterImage: string;
}
const testimonials: Testimonial[] = [{
  id: 1,
  name: "Jan Přívora",
  projectType: "Vysokotlaké čištění + impregnace střechy • Praha\xA0",
  location: "Praha 6",
  description: "Profesionální přístup, technická preciznost a prokazatelné výsledky. Střecha vypadá jako nová.",
  beforeImage: "https://vicistimtito.10web.cloud/wp-content/uploads/2026/02/unnamed-5.jpg?v=3a0c3vrwf1t",
  afterImage: "https://vicistimtito.10web.cloud/wp-content/uploads/2026/02/unnamed-6.jpg?v=syt00xe8mjf"
}, {
  id: 2,
  name: "Marie Svobodová",
  projectType: "Fotovoltaika • Brno\xA0",
  location: "Brno",
  description: "Férová cena a kvalitní komponenty. Oceňuji hlavně rychlost vyřízení a lidský přístup při vysvětlování systému.",
  beforeImage: "https://vicistimtito.10web.cloud/wp-content/uploads/2026/02/WhatsApp-Image-2026-01-24-at-18.08.35.jpeg",
  afterImage: "https://vicistimtito.10web.cloud/wp-content/uploads/2026/02/WhatsApp-Image-2026-01-24-at-18.21.42.jpeg?v=t8muxwkf7fe"
}, {
  id: 3,
  name: "Petr Dvořák",
  projectType: "Vysokotlaké čištění fasády",
  location: "Ostrava",
  description: "Fasáda vypadá po vyčištění doslova jako nová. Plísně a šedý povlak jsou pryč, práce byla hotová rychle a kvalitně.",
  beforeImage: "https://vicistimtito.10web.cloud/wp-content/uploads/2026/02/fasada-ref.pred_.png?v=ki2lzgnovf",
  afterImage: "https://vicistimtito.10web.cloud/wp-content/uploads/2026/02/fasada-ref.po_.png?v=z7g6ajsalro"
}, {
  id: 4,
  name: "V. Brož",
  projectType: "Čištění střechy a okapů • Krušovice\xA0",
  location: "Plzeň",
  description: "Kvalitně odvedená práce můžu jen doporučit.",
  beforeImage: "https://vicistimtito.10web.cloud/wp-content/uploads/2026/02/image3-1.jpeg?v=vkoxkcrg7ql",
  afterImage: "https://vicistimtito.10web.cloud/wp-content/uploads/2026/02/IMG_20251015_164252-1.jpg?v=220l1ql7oj5"
}];
export default function Reference() {
  return <section id="reference" className="dark bg-background text-foreground py-16 px-4 md:py-24">
      <div className="max-w-4xl mx-auto">
        <div className="mb-12 text-center">
          <h2 className="text-3xl md:text-4xl font-display mb-4">
            Reference našich klientů
          </h2>
          <p className="text-muted-foreground text-lg">
            Naše práce mluví za nás. Podívejte se na konkrétní projekty a
            výsledky, kterých jsme dosáhli.
          </p>
        </div>

        <div className="space-y-4">
          {testimonials.map((testimonial, i) => {
          return <Card key={testimonial.id} data-index={i} className="overflow-hidden shadow-strong border-primary/30">
                <CardContent className="p-6">
                  <div className="flex items-start gap-4">
                    <div className="flex-shrink-0 w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center">
                      <Quote className="w-5 h-5 text-primary" />
                    </div>
                    <div className="flex-1">
                      <h3 className="text-xl font-semibold mb-1">
                        {testimonial.name}
                      </h3>
                      <p className="text-muted-foreground text-sm">
                        {testimonial.projectType} • {testimonial.location}
                      </p>
                    </div>
                  </div>

                  <div className="grid grid-rows-[1fr] opacity-100 mt-6">
                    <div className="overflow-hidden">
                      <div className="space-y-6">
                        <p className="text-foreground leading-relaxed">
                          {testimonial.description}
                        </p>

                        <div className="grid md:grid-cols-2 gap-4">
                          <div className="space-y-2">
                            <div className="relative aspect-[4/3] rounded-lg overflow-hidden bg-secondary-dark">
                              <img src={testimonial.beforeImage} alt={`Před - ${testimonial.projectType}`} className="w-full h-full object-cover" />
                            </div>
                          </div>

                          <div className="space-y-2">
                            <div className="relative aspect-[4/3] rounded-lg overflow-hidden bg-secondary-dark">
                              <img src={testimonial.afterImage} alt={`Po - ${testimonial.projectType}`} className="w-full h-full object-cover" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </CardContent>
              </Card>;
        })}
        </div>
      </div>
    </section>;
}